import type { RouteRecordRaw } from 'vue-router';

export const salesOrdersRoutes: RouteRecordRaw[] = [
  {
    path: 'sales-orders',
    name: 'sales-orders',
    component: () => import('./pages/SalesOrdersListPage.vue'),
    meta: { title: 'Sales orders', requiresAuth: true, permission: 'view_sales_orders' },
  },
  {
    path: 'sales-orders/new',
    name: 'sales-orders.create',
    component: () => import('./pages/SalesOrderEditorPage.vue'),
    meta: { title: 'New sales order', requiresAuth: true },
  },
  {
    path: 'sales-orders/:id',
    name: 'sales-orders.show',
    component: () => import('./pages/SalesOrderEditorPage.vue'),
    meta: { title: 'Sales order', requiresAuth: true },
  },
];
